import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IpopConfiguration } from '../../../../../model/ipop-configuration.model';

@Component({
  selector: 'auto-vdp-offers',
  templateUrl: './vdp-offers.component.html',
  styleUrls: ['./vdp-offers.component.scss'],
  standalone: false
})
export class VdpOffersComponent implements OnInit, OnChanges {
  @Input() data: IpopConfiguration | null = null;
  @Output() formGroupInitialized = new EventEmitter<UntypedFormGroup>();

  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      vdpOfferWidgetEnabled:  [false, Validators.required],
      offerTextColor:         ['#000000', Validators.required],
      ctaTextFontSize:        [22, Validators.required],
      clickToCallTextFontSize:[22, Validators.required],
      ctaButtonColor:         ['#000000', Validators.required],
      clickToCallEnabled:     [true, Validators.required],
      clickToCallText:        ['[DealerPhone]', Validators.required],
      clickToCallBackgroundColor: ['#000000', Validators.required],
      clickToCallTextColor:   ['#ffffff', Validators.required],
    });
    this.formGroupInitialized.emit(this.form);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasIncoming = !!this.data && !!this.form;
    if (hasIncoming) {
      this.form.patchValue({
        vdpOfferWidgetEnabled: !!this.data.vdpOfferWidgetEnabled,
        offerTextColor:        this.data.offerTextColor || '#000000',
        ctaTextFontSize:       this.data.ctaTextFontSize || 22,
        clickToCallTextFontSize: this.data.clickToCallTextFontSize || 22,
        ctaButtonColor:        this.data.ctaButtonColor || '#000000',
        clickToCallEnabled:    this.data.clickToCallEnabled,
        clickToCallText:       this.data.clickToCallText,
        clickToCallBackgroundColor: this.data.clickToCallBackgroundColor,
        clickToCallTextColor:  this.data.clickToCallTextColor,
      }, { emitEvent: false });
      this.form.markAsPristine();
    }
  }
}
